<template>
    <div class="base-exam-container" v-loading="loading">
        <div class="base-exam-box">
            <div class="paper-head-box">
                <div class="paper-head-container">
                    <div class="l-side-paper-container">
                        <svg t="1775717777561" @click="backExamPaper('/hyedu/ques')" style="margin-top: 9px;" class="icon cursor" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5353" width="32" height="32"><path d="M404.032 233.344a32 32 0 1 1 45.248 45.312L247.872 480h605.44a32 32 0 0 1 31.488 26.24l0.512 5.76a32 32 0 0 1-32 32h-605.44l201.408 201.344a32 32 0 0 1 3.712 40.832l-3.712 4.48a32 32 0 0 1-45.248 0l-256-256-0.64-0.896-1.216-1.152-0.896-1.344-0.96-1.088-0.64-1.152-0.64-0.896-0.64-1.344-0.832-1.472-0.32-1.152-0.64-1.024-0.256-1.536-0.64-1.472-0.192-1.472-0.32-0.896-0.064-1.216-0.384-1.792V513.28L138.752 512l0.128-1.28v-1.472l0.32-1.856V506.24l0.384-0.96 0.192-1.408 0.64-1.536 0.32-1.472 0.576-1.088 0.32-1.088 0.896-1.536 0.576-1.28 0.64-0.96 0.64-1.088 0.96-1.152 0.896-1.28 1.216-1.216 0.64-0.832 256-256z" fill="#0d55a4" p-id="5354"></path></svg>
                    </div>
                    <div class="mid-paper-container">恒岳组卷中心</div>
                    <div class="r-side-paper-container cursor">
                        <el-avatar style="margin-top: 7px;" :size="36" :src="userInfo.avatar + '?_=' + Date.now()" />
                    </div>
                </div>
            </div>
            <div class="exam-container">
                <div class="l-exam-container">
                    <div class="exam-title-container">
                        {{basketInfo.basketName}}
                    </div>
                    <div  v-for="(parItem,index) in quesClassifyList">
                        <div class="exam-classify-title">
                            {{quesNoList[index]}}{{parItem.quesCateName}}（共{{parItem.quesCount}}小题）
                        </div>
                        <div class="exam-list-container">
                            <div class="exam-item" v-for="(item,indexs) in parItem.quesList" :key="item.ques.sid">
                                <!-- 试题内容 -->
                                <div class="pt1" >
                                    <span class="qseq">{{indexs+1}}．</span>
                                    <a v-if="item.ques.label">{{item.ques.label}}</a>
                                    <span v-html="item.ques.content"></span>
                                </div>
                                <!-- 选项 -->
                                <div class="pt2" v-if="item.ques.options&&item.ques.options.length>0>0&&item.ques.options[0].length<10">
                                    <table style="width:100%" class="ques quesborder">
                                        <tr>
                                            <td style="width:23%" class="selectoption" v-for="(option,oIndexs) in item.ques.options">
                                                <div class="cursor" v-if="oIndexs===0">A．<span v-html="option"></span></div>
                                                <div class="cursor"  v-if="oIndexs===1">B．<span v-html="option"></span></div>
                                                <div class="cursor"  v-if="oIndexs===2">C．<span v-html="option"></span></div>
                                                <div class="cursor"  v-if="oIndexs===3">D．<span v-html="option"></span></div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="pt2" v-if="item.ques.options&&item.ques.options.length>0&&item.ques.options[0].length>=10">
                                    <table style="width:100%" class="ques quesborder">
                                        <tr v-for="(option,oIndexs) in item.ques.options">
                                            <td style="width:98%" class="selectoption" >
                                                <div class="cursor"  v-if="oIndexs===0">A．<span v-html="option"></span></div>
                                                <div class="cursor"  v-if="oIndexs===1">B．<span v-html="option"></span></div>
                                                <div class="cursor"  v-if="oIndexs===2">C．<span v-html="option"></span></div>
                                                <div class="cursor"  v-if="oIndexs===3">D．<span v-html="option"></span></div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="r-exam-container">

                    <div class="exam-submit-container">
                        <div class="exam-submit-btn" @click="viewPaper">我的组卷</div>
                    </div>

                    <div class="exam-submit-container" style="margin-top: 20px;">
                        <div class="exam-submit-btn" @click="openPaperInfo">提交组卷</div>
                    </div>


                </div>
            </div>
        </div>
    </div>

    <el-dialog title="提交组卷" v-model="isShowPaperDialog" width="400px">
        <el-form ref="paperFormRef" :rules="paperFormRules" :model="paperForm"
                 label-width="80px" class="meeting-form">
            <el-row style="width: 100%;">
                <el-form-item  label="组卷名称" prop="paperName" style="width: 100%;">
                    <el-input v-model="paperForm.paperName" placeholder="请输入组卷名称，如'2025中考压轴题'" />
                </el-form-item>
            </el-row>
            <el-row style="width: 100%;">
                <el-form-item  label="考试时长" prop="times" style="width: 100%;">
                    <el-input-number v-model="paperForm.times" :min="1"  label="请输入考试时长" />
                </el-form-item>
            </el-row>
            <el-row style="width: 100%;">
                <el-form-item style="width: 100%;">
                    <el-button type="primary" @click="submitGeneratePaper">确定</el-button>
                    <el-button @click="isShowPaperDialog = !isShowPaperDialog">取消</el-button>
                </el-form-item>
            </el-row>
        </el-form>
    </el-dialog>

    <!--备课列表-->
    <el-dialog title="组卷列表" v-model="isShowPaperListDialog" width="800px">
        <el-table show-overflow-tooltip height="calc(100vh - 300px)"
                  border  highlight-current-row
                  :data="paperList">
            <el-table-column type="index" align="center" label="序号" width="60" />
            <el-table-column width="" align="center" label="组卷名称" prop="paperName">
                <template #default="scope">
                    <div :title="scope.row.paperName" style="color: #409efe;" class="text-one cursor">
                        {{ scope.row.paperName }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column width="90" align="center" label="考试时长（分钟）" prop="times">
            </el-table-column>
            <el-table-column width="80" align="center" label="总分" prop="score">
            </el-table-column>
            <el-table-column width="180" align="center" label="组卷时间" prop="createTime">
                <template #default="scope">
                    <div>
                        {{ timestampToTime(scope.row.createTime) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" align="center" width="100">
                <template #default="scope">
                    <el-button type="primary" size="small" @click="downloadPaperFile(scope.row)">
                        下载
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
import {timestampToTime} from "@/utils/date";
import {jyeooDate} from "@/utils/str"
import {downloadFile} from "@/api/adminservice/public"
import {queryBasket, generatePaper, listPaper,downloadPaper} from "@/api/admin/paper";

export default {
    name: "HomePaperCenter",
    components: {},
    data() {
        return {
            loading:true,
            isShowPaperDialog:false,
            isShowPaperListDialog:false,
            subjectEnName:'',
            sp:'',
            timestampToTime,
            jyeooDate,
            userInfo : JSON.parse(this.$storage.get("userInfo")),
            basketInfo:{},
            basketQuesCount:0,
            basketQuesIds:"",
            quesClassifyList:[],// 试题分类列表
            quesNoList:[
              "一．", "二．", "三．", "四．","五．",
              "六．", "七．", "八．", "九．", "十．",
              "十一．", "十二．", "十三．", "十四．", "十五．",
            ],
            paperForm:{
                basketId:"",
                paperSubject:"",
                paperName:"",
                times:0,
            },
            paperFormRules:{
                paperName: [{ required: true, message: "请输入腾讯会议号", trigger: "change" },],
                times: [{ required: true, validator: this.checkPaperTime }],
            },
            downloadPaper:{
                paperId:'',
                method:7,
                docx:1, // docx
                size:1,
            },
            paperList:[],
        };
    },
    created() {
        if (this.$route.query.sen&&this.$route.query.sp) {
            this.sp = this.$route.query.sp;
            this.subjectEnName = this.$route.query.sen;
            this.paperForm.paperSubject = this.$route.query.sen;
            this.queryBasketInfo();
            this.queryPaperList();
        }
    },
    mounted() {
    },
    activated() {
    },
    watch: {
    },
    methods: {
        checkPaperTime(rule, value, callback){
            if (!this.paperForm.times || this.paperForm.times<=0) {
                callback(new Error('开始时长时间不合法'))
            } else {

            }
        },
        backExamPaper(path){
            this.$router.push(path+'?sp='+this.sp);
        },
        // 查询试题篮
        queryBasketInfo(){
            queryBasket({ subjectEnName: this.subjectEnName }).then(res => {
                if (res.data.code === 1) {
                    this.loading = false;
                    this.basketInfo = res.data.data;
                    this.paperForm.basketId = this.basketInfo.basketId;
                    this.basketQuesCount = this.basketInfo.quesCount;
                    this.basketQuesIds = this.basketInfo.quesIds;
                    this.quesClassifyList = this.basketInfo.qcList;
                }else {
                    this.loading = false;
                }
            });
        },
        openPaperInfo(){
            this.isShowPaperDialog = true;
        },
        viewPaper(){
            this.isShowPaperListDialog = true;
        },
        // 提交生成 组卷
        submitGeneratePaper(){
            this.loading = true;
            if (!this.paperForm.paperName){
                this.$message.error("请填写组卷名称")
                return;
            }
            generatePaper(this.paperForm).then(res => {
                if (res.data.code === 1) {
                    this.queryPaperList();
                    this.isShowPaperDialog = false;
                    this.loading = false;
                }else {
                    this.loading = false;
                    this.$message.error("请求出错")
                }
            });
        },
        // 查询组卷
        queryPaperList(){
            listPaper().then(res => {
                if (res.data.code === 1) {
                    this.paperList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            });
        },
        // 下载组卷
        downloadPaperFile(item){
            this.downloadPaper.paperId = item.paperId;
            downloadPaper(this.downloadPaper).then(res => {
                if (res.data.code === 1) {
                    downloadFile(res.data.data,item.paperName);
                }else {
                    this.$message.error("请求出错")
                }
            });
        },
    }
};
</script>
<style lang="scss" scoped>
.base-exam-container{
    width: 100%;
    height: 100%;
    overflow-y: auto!important;
    overflow-x: hidden;
    background-color: #f5f5f5;
}
.base-exam-box {
    width:100%;
    height: auto;
    overflow-y: auto!important;
}
.paper-head-box{
    width: 100%;
    height: 52px;
}
.paper-head-container{
    height: 50px;
    width: 100%;
    line-height: 48px;
    box-shadow: 0 1px 12px 0 rgba(0, 58, 129, 0.08);
    background-color: #fff;
    display: flex;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.l-side-paper-container{
    width: 60px;
    height: 50px;
}
.r-side-paper-container{
    width: 60px;
    height: 50px;
}
.mid-paper-container{
    width: calc(100% - 120px);
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    color: #0d55a4;
    font-weight: bold;
    font-family: sans-serif;
    text-align: center;
}
.exam-container{
    width: 100%;
    height: auto;
    margin: auto;
    display: flex;

}
.l-exam-container{
    width: calc(100% - 300px);
    height: auto;
    background-color: #fff;
    padding: 0 30px 0 30px;
    box-sizing: border-box;
    margin-top: 10px;
}
.exam-list-container{
    width: 100% ;
    padding: 0 0 0 0;
    margin: auto;
    box-sizing: border-box;
    height: auto;
}
.exam-item{
    width: 100%;
    height: auto;
    margin-top: auto;
    margin-bottom: 10px;
    border-radius: 5px;
    border: 1px solid #dadada;
    cursor: pointer;
}
.exam-item:hover{
    border: 1px solid #0d55a4!important;
    border-radius: 5px;
}
.exam-title-container{
    width: 100%;
    height: 50px;
    color: #333333;
    line-height: 50px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    padding-top: 10px;
}
.exam-classify-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-weight: bold;
    font-size: 14px;
    color: #333333;
}

.r-exam-container{
    width: 280px;
    height: 300px;
    margin-left: 20px;
    margin-top: 10px;
}
.exam-submit-container{
    width: 100%;
    height: 60px;
    padding: 11px 0 11px 0;
    box-sizing: border-box;
    background-color: #fff;

}
.exam-submit-btn{
    width: 240px;
    height: 38px;
    background: #0d55a4;
    color: #fff;
    border-radius: 5px;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    display: flex;
    margin: auto;
    cursor: pointer;
}
</style>